import { useEffect, useRef } from 'react';
import classnames from 'classnames';
import { IMaskInput } from 'react-imask';
import IconClear from '@scramble/design-system/icons/x-close.svg';
import { CURRENCY } from '@scramble/utils';
import { MoneyFieldProps } from './types';
import s from './index.module.scss';

export const MoneyField = ({
  label,
  name,
  value,
  placeholder,
  onChange,
  onClear,
  error,
  description,
  rightContainer,
  isFloat,
}: MoneyFieldProps) => {
  const maskedValue = useRef(value.toString());

  useEffect(() => {
    maskedValue.current = value.toString();
  }, [value]);

  return (
    <div className={s.wrapper}>
      {label && (
        <label htmlFor={name} className={s.label}>
          {label}
        </label>
      )}
      <div className={s.container}>
        <div className={s.left_container}></div>
        <IMaskInput
          id={name}
          mask={`${CURRENCY}num`}
          blocks={{
            num: {
              mask: Number,
              thousandsSeparator: "'",
              radix: isFloat ? '.' : undefined,
              scale: isFloat ? 2 : 0,
              mapToRadix: [','],
              min: 0,
              max: 9999999,
            },
          }}
          className={classnames(s.input, error && s.input_error, 'money_field__input')}
          value={maskedValue.current}
          placeholder={placeholder}
          onAccept={(val: string, mask: { unmaskedValue: string }) => {
            maskedValue.current = val;
            onChange(mask.unmaskedValue);
          }}
        />
        <div className={s.right_container}>
          {rightContainer ||
            (onClear && !!value && (
              <button type="button" className={s.btn_clear} onClick={onClear}>
                <img src={IconClear} width={16} height={16} alt="clear" />
              </button>
            ))}
        </div>
      </div>
      {error ? (
        <div className={s.error}>{error}</div>
      ) : (
        description && <div className={s.description}>{description}</div>
      )}
    </div>
  );
};